import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useQueryClient, useQuery } from 'react-query'
import { useHistory } from 'react-router-dom'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { deleteDocumentById, getAllData } from '../../lib/RestApi/customApiHandler'
import { createDocument, updateDocumentByID } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'
import { useFeatures } from '../../hooks/Features/useFeatures'
import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
import { UserContext } from '../../context api/UserContext'
import { toastMessage } from '../../shared/AlertPopup'

export default function AddTravelRequest({ allowanceRequest: allowanceRequestData }) {
  const user = useContext(UserContext)
  const queryClient = useQueryClient()
  const history = useHistory()
  const debouncedValue = useDebounce('', 500)
  const { travelCategories, getTravelCat, getAllowanceTypes, allowanceTypes} = useFeatures()
  const { getAllEmployee, getEmployeeByRank, updateEmployee, getEmployee, employee: emp, rankedEmployees} = useCompanyAdmin()
  // let { data: travelCategory, isLoading } = useQuery(['travel-category', debouncedValue && debouncedValue], () => getAllData('/travel/category', { }))
  const [allowanceRequest, setAllowanceRequest] = useState({
    date: allowanceRequestData ? allowanceRequestData.date : new Date(),
    from: allowanceRequestData ? allowanceRequestData.from : new Date(),
    to: allowanceRequestData ? allowanceRequestData.to : new Date(),
    amount: allowanceRequestData ? allowanceRequestData.amount : '',
    remarks: allowanceRequestData ? allowanceRequestData.remarks : '',
    images: allowanceRequestData ? allowanceRequestData.images : [],
    travelCategory: allowanceRequestData ? allowanceRequestData.travelCategory : '',
    multipleDays: allowanceRequestData ? allowanceRequestData.from && true : false,
  })

  useEffect(()=>{
    getEmployeeByRank({rank: 6})
    if(allowanceRequest.allowanceType)
      getTravelCat({allowanceType: allowanceRequest.allowanceType});
  }, [ allowanceRequest.allowanceType])

  useEffect(()=>{
    if(!allowanceRequest.allowanceType)
      getAllowanceTypes();
  }, [allowanceRequest.allowanceType])
  const data = [
    { label: 'Allowance Type', value: allowanceRequest.allowanceType, name: 'allowanceType', options: allowanceTypes, fieldName: "name", fieldValue: "_id" },
    { label: 'Travel Category', value: allowanceRequest.travelCategory, name: 'travelCategory', options: travelCategories && travelCategories, fieldName: "name", fieldValue: "_id" },
    { label: 'Employee', value: allowanceRequest.employee, name: 'employee', options: rankedEmployees && rankedEmployees, fieldName: "firstName", fieldValue: "_id", noDisplay: user.userType!== "COMPANYADMIN" },
    { label: 'Amount', value: allowanceRequest.amount, name: 'amount', type: 'NUMBER' },
    { label: 'Multiple Days', type: "SWITCH", value: allowanceRequest.multipleDays, name: 'multipleDays' },
    { label: 'Date', type: 'DATE', value: allowanceRequest.date, name: 'date', default: new Date(), maxDate: new Date(), disabled : allowanceRequest.multipleDays, noDisplay: allowanceRequest.multipleDays },
    { label: 'From', type: 'DATE', value: allowanceRequest.from, name: 'from', default: new Date(), disabled : !allowanceRequest.multipleDays, noDisplay: !allowanceRequest.multipleDays   },
    { label: 'To', type: 'DATE', value: allowanceRequest.to, name: 'to', default: new Date(), minDate: allowanceRequest.from, disabled : !allowanceRequest.multipleDays, default: Date.now(), noDisplay: !allowanceRequest.multipleDays   },
    { label: 'Remarks', value: allowanceRequest.remarks, name: 'remarks' },
    { label: 'Images', type: "IMAGE", value: allowanceRequest.images, name: 'images', multiple: true, s3upload: true, limit: 250000, noOfFiles: 3},

]

  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    // setLoading(true)
    if (allowanceRequestData) {
      const data = await updateDocumentByID('/update/allowanceType', allowanceRequestData._id, allowanceRequest)
      queryClient.invalidateQueries('edit-allowance')
      if(data) toastMessage('edited successfully!', 'success')
      setLoading(false)
    } else {        
      const data = await createDocument('/create/allowance/request', allowanceRequest)
      queryClient.invalidateQueries('post-allowance')
      if(data) toastMessage('added successfully!', 'success')
      setLoading(false)
    }

    history.push('/travel-requests')
  }
  return (
    <CustomAddPage
      heading="Travel Requests"
      redirect={'TRAVEL_REQUESTS'}
      currentData={allowanceRequest}
      loading={loading}
      state={allowanceRequest}
      setState={setAllowanceRequest}
      handleClick={handleClick}
      inputFields={data}
    />
  )
}
